import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowUpRight, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const TYPES = ["Trade / Distribution", "Restaurant & Bar", "Events & Festivals", "Press", "Other"];
const EMPTY = { name: "", email: "", company: "", enquiry_type: TYPES[0], message: "" };

export default function EnquiryForm() {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!API) { toast.error("Enquiries are unavailable right now. Please email info@himachalcider.com"); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/api/enquiries`, form);
      toast.success("Thank you! Your enquiry is with the Himachal हो! team. JAI हो!");
      setForm(EMPTY);
    } catch (err) {
      toast.error(err?.response?.data?.detail?.[0]?.msg ?? "Could not send. Please email info@himachalcider.com");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="trade-enquiry-form" className="rounded-[1.5rem] border border-white/30 bg-white/10 p-6 backdrop-blur-xl sm:p-10">
      <p className="eyebrow text-white">Trade & enquiries</p>
      <p className="mt-3 font-display text-3xl font-semibold">Stock it, pour it, celebrate with it.</p>
      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2">
        <input required data-testid="enquiry-name-input" className="field" placeholder="Your name" value={form.name} onChange={set("name")} />
        <input required type="email" data-testid="enquiry-email-input" className="field" placeholder="Email" value={form.email} onChange={set("email")} />
        <input data-testid="enquiry-company-input" className="field" placeholder="Company / venue (optional)" value={form.company} onChange={set("company")} />
        <select data-testid="enquiry-type-select" className="field [&>option]:bg-forest" value={form.enquiry_type} onChange={set("enquiry_type")}>
          {TYPES.map((t) => <option key={t}>{t}</option>)}
        </select>
        <textarea required minLength={5} rows={4} data-testid="enquiry-message-input" className="field resize-none sm:col-span-2" placeholder="Tell us about your venue, event or idea" value={form.message} onChange={set("message")} />
      </div>
      <button type="submit" disabled={busy} data-testid="trade-enquiry-submit-btn" className="btn-gold mt-8 disabled:opacity-70">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null} Send enquiry <ArrowUpRight className="h-4 w-4" />
      </button>
    </form>
  );
}
